import { render, staticRenderFns } from "./layoutIndex.vue?vue&type=template&id=ef394fb4"
import script from "./layoutIndex.vue?vue&type=script&lang=js"
export * from "./layoutIndex.vue?vue&type=script&lang=js"
import style0 from "./layoutIndex.vue?vue&type=style&index=0&id=ef394fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports